// extracted by mini-css-extract-plugin
export default {"banners":"DashboardBanners_banners__3i8hC"};